import { TextField } from "@mui/material";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from "react";
import { useDispatch, useSelector } from "react-redux";
import ageToYear, { yearToAge } from "../../../utility/ageToYear";

const DeathOfBirth = forwardRef((props, ref) => {
  const [age, setAge] = useState("");
  // UseRef
  useImperativeHandle(ref, () => ({
    // getAlert() {
    //   alert("alert form Age");
    // },
    resetFormData,
  }));
  // UseRef //
  const resetFormData = () => {
    setAge(''); 
  };
  const birthYear = useSelector((state) => state.birthOfYear);
  const dispatch = useDispatch();
  
  
  const handleAgeChange = (age) => {
    setAge(age);
    const birthOfYear = ageToYear(age);
    // setBirthYear(birthOfYear);
    dispatch({
      type: "birthOfYear_add",
      payload: birthOfYear,
    });
  };
  const handleBirthOfYearChange = (birthYear) => {
    // setAge(age);
    // setBirthYear(birthYear);
    setAge(yearToAge(birthYear));
    dispatch({
      type: "birthOfYear_add",
      payload: birthYear,
    });
  };
  useEffect(() => {
    if (birthYear > 0) {
      setAge(yearToAge(birthYear));
    }
  }, [birthYear]);
  return (
    <div>
      <TextField
        sx={{ width: 70, mr: 1 }}
        value={age}
        onChange={(e) => handleAgeChange(e.target.value)}
        size="small"
        label={"Age"}
      ></TextField>
      {/* <TextField sx={{width:100,mr:1}} value={birthYear} onChange={e=>handleBirthOfYearChange(e.target.value)} size="small" label={"Birth of Year"} ></TextField> */}
      {/* <Controller
                name="dob_year"
                control={control}
                render={({ field }) => (
                  <TextField
                    sx={{ mx: 1 }}
                    size="small"
                    label="Birth of Year"
                    {...field}
                    value={birthYear} onChange={e=>handleBirthOfYearChange(e.target.value)}
                  />
                )}
              />

               */}
      <TextField
        sx={{ mx: 1 }}
        size="small"
        label="Birth of Year"
        value={birthYear}
        onChange={(e) => handleBirthOfYearChange(e.target.value)}
      />
    </div>
  );
});

export default DeathOfBirth;
